export default "__VITE_ASSET__Drd0ZY2J__"